import React from "react";
import "./styles.scss";
import { useNavigate } from "react-router-dom";

import Button from "../../../common/button";

const FallPrevention = ({ data }) => {
  const { button_text, icons } = data;
  const Navigate = useNavigate();

  return (
    <div className="fall-prevention-container">
      <div className="sub-division">
        {icons?.length
          ? icons?.map((item, index) => {
              return (
                <div key={`fall_prevention_${index}`} className="sub-container">
                  <div>
                    <img src={item.image} alt={item.title} />
                  </div>
                  <h3>{item.title}</h3>
                </div>
              );
            })
          : null}
      </div>
      <div className="btn">
        {button_text && (
          <Button
            onClick={() => Navigate(`${process.env.REACT_APP_BASE}/risk-fall`)}
          >
            {button_text}
          </Button>
        )}
      </div>
    </div>
  );
};

export default FallPrevention;
